import { render, staticRenderFns } from "./ReminderInsuranceTable.vue?vue&type=template&id=0eb93354&"
import script from "./ReminderInsuranceTable.vue?vue&type=script&lang=js&"
export * from "./ReminderInsuranceTable.vue?vue&type=script&lang=js&"
import style0 from "./ReminderInsuranceTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports